import { Injectable } from '@angular/core';
import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import moment from 'moment-timezone';

// import 'moment-timezone';

@Injectable()
export class DateTimeService {
    private serverTimeZone = 'America/Los_Angeles';

    constructor() {
        dayjs.extend(utc);
        dayjs.extend(timezone);
    }

    public formatToStartOfDayPacificTimezone(date: string | number | Date | Dayjs): string {
        return dayjs(date)
            .startOf('day')
            .tz('America/Los_Angeles')
            .startOf('day')
            .format();
    }

    public formatToEndOfDayPacificTimezone(date: string | number | Date | Dayjs): string {
        return dayjs(date)
            .endOf('day')
            .tz('America/Los_Angeles')
            .endOf('day')
            .format();
    }

    public formatAsPacificTimezone(date: string | number | Date | Dayjs): string {
        return dayjs
            .tz(date, 'America/Los_Angeles')
            .format();
    }

    public toServerDateTimeString(dateTime: Date | string, format = 'YYYY-MM-DD'): string {
        // return moment(dateTime).tz(this.serverTimeZone).format(format);
        return moment(dateTime).startOf('day').format(format);
    }
}
